import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Indie startup more profitable than Uber 😛",
  "description": "",
  "published": "2019-02-18T00:00:00.000Z",
  "redirect_from": ["/blog/indie-startup-more-profitable-than-uber-%f0%9f%98%9b/swizec/8947"],
  "categories": "Business, Side Projects",
  "hero": "./img/media-Dzkrr5KUcAErAzP.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2019/02/IMG_0266-1024x575.jpg",
        "alt": null
      }}></img><em parentName="p">{`You don't need millions of dollars, thousands of employees, and a groundbreaking idea. 2 hours per day, some help, and an okay idea is all you need to build a business that's more profitable than Uber.`}</em></p>
    <p>{`I'm poking fun at Uber racing towards IPO `}<a parentName="p" {...{
        "href": "https://www.bloomberg.com/news/articles/2019-02-15/uber-results-show-revenue-growth-slows-amid-persistent-losses"
      }}>{`despite record breaking losses`}</a>{` of course, but there is a lesson. My Twitter thread from Saturday got a lot of love so I wanted to share it with you and add some answers to common questions.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Some fun stats from product sidehustle land 👇`}<br parentName="p"></br><br parentName="p"></br>{`Since March 2015`}<br parentName="p"></br><br parentName="p"></br>{`2695 hours`}<br parentName="p"></br>{`1.8 hrs/day average`}<br parentName="p"></br><br parentName="p"></br>{`3-ish products`}<br parentName="p"></br>{`~2800 sales`}<br parentName="p"></br>{`$139,208 revenue post fees`}<br parentName="p"></br>{`$81,767 expenses`}<br parentName="p"></br><br parentName="p"></br>{`$21/hour 🤔`}<br parentName="p"></br><br parentName="p"></br>{`This must be why most people share only the revenue numbers `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/open?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#open`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1096953072385875968"
      }}>{`February 17, 2019`}</a></blockquote>
    <h2 {...{
      "id": "but-why"
    }}>{`But why?`}</h2>
    <p>{`Now the obvious question: Why would anyone do this?`}</p>
    <p>{`Well for starters it's still better than a coding job back home. My first job building websites was for $7/hour.`}</p>
    <p>{`That was in high school.`}</p>
    <p>{`I eventually got better jobs, yes. Mostly thanks to moving into freelancing, being picky about clients, and choosing to work for foreign clients (primarily US startup land) whenever possible.`}</p>
    <p>{`That got me to about $70,000/year. It was great. Lived like a king.`}</p>
    <p>{`Median wage in Slovenia is around $25,000/year by the way. That was my environment.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/918becc27cb20e2770778b2e43009ce1/7e1b6/media-Dzkrr5KUcAErAzP.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.008968609865473%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'104\\'%20viewBox=\\'0%200%20400%20104\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918becc27cb20e2770778b2e43009ce1/ca0a1/media-Dzkrr5KUcAErAzP.webp 223w", "/static/918becc27cb20e2770778b2e43009ce1/75680/media-Dzkrr5KUcAErAzP.webp 445w", "/static/918becc27cb20e2770778b2e43009ce1/8d1ba/media-Dzkrr5KUcAErAzP.webp 890w", "/static/918becc27cb20e2770778b2e43009ce1/2b4a4/media-Dzkrr5KUcAErAzP.webp 1310w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918becc27cb20e2770778b2e43009ce1/853b2/media-Dzkrr5KUcAErAzP.jpg 223w", "/static/918becc27cb20e2770778b2e43009ce1/0a4fe/media-Dzkrr5KUcAErAzP.jpg 445w", "/static/918becc27cb20e2770778b2e43009ce1/7f80b/media-Dzkrr5KUcAErAzP.jpg 890w", "/static/918becc27cb20e2770778b2e43009ce1/7e1b6/media-Dzkrr5KUcAErAzP.jpg 1310w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/918becc27cb20e2770778b2e43009ce1/7f80b/media-Dzkrr5KUcAErAzP.jpg",
                "alt": "Google result for \"Slovenia median wage\"",
                "title": "Google result for \"Slovenia median wage\"",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Google result for "Slovenia median wage"`}</figcaption>{`
  `}</figure></p>
    <p>{`Google result for "Slovenia median wage"`}</p>
    <p>{`So at about $70k I was making bank.`}</p>
    <p>{`But I soon realized that selling your time doesn't scale. There's only so much time you can sell.`}</p>
    <p>{`Even with productized consulting, you're still doing the work. You have to sit down and do the things. Your only way to scale is charging more.`}</p>
    <p>{`Charging more has limits too. At some point clients are gonna be like "`}<em parentName="p">{`Yeah no we'd rather hire a team of people we don't care how good you are or how much competition there is for your time"`}</em></p>
    <p>{`And even then. If you can't do the work, you don't get paid. This creates all sorts of weird incentives.`}</p>
    <p>{`Imagine taking a vacation when a day of your time is worth $5000. Or $10,000.`}</p>
    <p>{`Pretty hard right?`}</p>
    <h2 {...{
      "id": "compounding-and-free-time"
    }}>{`Compounding and free time`}</h2>
    <p>{`Products don't have this problem. It doesn't matter what your product is: a SaaS, a book, a course, or something else. They all follow the same laws.`}</p>
    <p>{`Products provide value when you aren't working.`}</p>
    <p>{`That means you can make money when you're not working.`}</p>
    <p>{`And that's when everything changes.`}</p>
    <p>{`If you buy my book or course (or read a blog), I don't have to be there. You're getting value while I'm working on the next thing, or sweating at the gym, or anything really.`}</p>
    <p>{`My value to society is no longer bound to time spent working.`}</p>
    <p>{`Now this whole value-detached-from-time concept, it follows the laws of compound returns.`}</p>
    <p>{`First you operate at a loss. You're putting in the work and nothing happens.`}</p>
    <p>{`Also known as the `}<a parentName="p" {...{
        "href": "https://baremetrics.com/blog/long-slow-saas-ramp-of-death"
      }}>{`SaaS ramp of death`}</a>{`.`}</p>
    <p>{`But every blog you write, every course you launch, every book you publish, every customer you get. They build on one another. They lead to more sales, more ideas, more things you can make.`}</p>
    <p>{`Everything compounds.`}</p>
    <p>{`And if all goes well, eventually, with some luck, you make more money from products than you ever could from selling your time.`}</p>
    <p>{`That's the beauty of it. That's what makes the initial pain worth it.`}</p>
    <h2 {...{
      "id": "so-whats-expenses-anyway"
    }}>{`So what's expenses anyway?`}</h2>
    <p>{`Several people asked what counts as "expenses" to make up that whopping $81,767 figure up there. Don't feel like recalculating exact numbers so here's a list in descending order of magnitude:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Ads.`}</strong>{` You need ads in the modern digital age. Think of it as paying rent for your storefront in the olden days. This includes newsletter sponsorships, facebook, twitter, reddit, etc.`}</li>
      <li parentName="ol"><strong parentName="li">{`Freelancers.`}</strong>{` You can do a lot yourself, but with 2 hours/day your time is limited. Delegate.`}</li>
      <li parentName="ol"><strong parentName="li">{`SaaS`}</strong>{` Another way to save time is software. SaaS-es built by others. This includes email list software, server hosting, payment processing apps, Zapier stuff, all sorts of things.`}</li>
    </ol>
    <p>{`In my tax returns I also include technology purchases (laptops, cameras, etc) as my expenses, some travel time when I can, online courses I take, and books I buy. Anything that helps my business goes into reducing taxes.`}</p>
    <p>{`But I didn't include it in the number above because it's not directly related.`}</p>
    <h2 {...{
      "id": "you-really-track-your-time-that-carefully"
    }}>{`You really track your time that carefully?`}</h2>
    <p>{`Yes. How will you know your investment is worth it, if you don't know how much you invested?`}</p>
    <p>{`My time on "sidehustle" includes writing blogs, these emails, working on the products themselves, marketing, customer support, videos, etc.`}</p>
    <h2 {...{
      "id": "swiz-im-an-employee-not-a-consultant-or-freelancer"
    }}>{`Swiz, I'm an employee not a consultant or freelancer`}</h2>
    <p>{`That's okay. You're still selling your time and your "scale" depends on charging more and more for your services.`}</p>
    <p>{`A good way to scale beyond Just Time as an employee is to go into management of some sort. When you're responsible for the output of 5, 10, 500 employees, that's worth a lot.`}</p>
    <p>{`The management track also affords you the benefits of providing value without working. When you delegate well enough your team can keep providing value even when you're on vacation.`}</p>
    <p>{`And you get paid vacation time so you never run into the weird incentive of vacations having opportunity cost. That's great 👌`}</p>
    <p>{`If you get equity, with a little luck, you might even have compound returns on your input. Depends how the company goes, but that's not in your control.`}</p>
    <h2 {...{
      "id": "wait-21hour-are-you-kidding-me"
    }}>{`Wait, `}{`\\`}{`\\`}{`\\`}{`$21/hour are you kidding me?`}</h2>
    <p>{`This is where people outside the US says `}<em parentName="p">{`"Holy shit that's amazing!!"`}</em>{` and people inside the US go `}<em parentName="p">{`"Eh that's barely better than a Starbucks barista"`}</em>{`. Coastal US people at least. 😅`}</p>
    <p>{`Yes it's true, you can make 5x that as an engineer.`}</p>
    <p>{`Charge $100/hour for writing code and no-one bats an eye. Even a full-time job with benefits and equity and all the rest pays at least $45/hour for an engineer. Probably more.`}</p>
    <p>{`But you know what? This is on top of a full-time job and it scales. That number's only gonna go up. First you invest, then you gain ✌️`}</p>
    <h2 {...{
      "id": "what-could-you-do-with-an-extra-57000"
    }}>{`What could you do with an extra `}{`\\`}{`\\`}{`\\`}{`$57,000?`}</h2>
    <p>{`That's the real question. An extra $57,000 on top of your salary after expenses. What could you do with that?`}</p>
    <p>{`Pay-off your loans? Downpayment for a house? Buy a car or three? Travel the world for 1 year `}<a parentName="p" {...{
        "href": "https://www.instagram.com/wanderingadeux/"
      }}>{`like my friends are`}</a>{`?`}</p>
    <p>{`And that brings us nicely to `}<a parentName="p" {...{
        "href": "https://ti.to/real-world-react/modern-app-with-react-workshop"
      }}>{`my Reactathon workshop about building and launching full-stack web apps`}</a>{` that's almost sold out.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Wat both early bird tiers for my "Build a whole React app" workshop already sold out at Reactathon`}<br parentName="p"></br><br parentName="p"></br>{`O.O `}<a parentName="p" {...{
          "href": "https://t.co/LsMASLi2Of"
        }}>{`pic.twitter.com/LsMASLi2Of`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1097361230799429632"
      }}>{`February 18, 2019`}</a></blockquote>
    <p>{`I didn't mean this to be a pitch but it just fits so nice 😇`}</p>
    <h1 {...{
      "id": "in-other-news"
    }}>{`In other news`}</h1>
    <p>{`Launch prep for React for Data Visualization is in full swing. I know it doesn't really fit the tone of this email but I'm excited. Been working on this for months 😅`}</p>
    <p>{`Got a new chapter on using React Hooks yesterday, a bunch of extra videos for the more theoretical sections and furiously writing copy for the launch. First time that I'm planning a launch in advance and not just flying by the seat of my pants.`}</p>
    <p>{`Wish me luck and enjoy your week 😘`}</p>
    <p>{`Cheers, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      